import React from 'react'
import FaAngleDown from 'react-icons/lib/fa/angle-down'
import { Loading, Calendar, SpeedGraph, TableDay } from '../../components'
import styles from './DailyWorkoutPage.styl'
import moment from 'moment'
import { withContext } from '../../../utils/withContext'
import { object, any } from 'prop-types'
import { connect } from 'react-redux'

class DailyWorkoutPage extends React.Component {

	static propTypes = {
		location: object,
		history: object,
		context: object,
		fetchAction: any,
		fetchResults: object
	}

	constructor(props) {
		super(props)
		const date = moment.utc(props.location.state || moment().format().slice(0, 10)).startOf('day')
		if (props.location.state) { props.history.replace({ pathname: props.location.pathname }) }
		this.fetchWorkoutByDate(date.valueOf())
		this.state = { results: true, date }
		this.hideStuff = this.hideStuff.bind(this)
		this.handleDateChange = this.handleDateChange.bind(this)
	}
	fetchWorkoutByDate(date) {
		const { fetchAction } = this.props
		fetchAction(`/api/athletes/workout/${ date }`, ['FETCH_QUERIES_START', 'FETCH_QUERIES_SUCCESS', 'FETCH_QUERIES_REJECT'], { fetchUrl: date })
	}
	hideStuff() {
		this.setState(prevState => ({ results: !(prevState.results) }))
	}

	handleDateChange(date) {
		this.fetchWorkoutByDate(date.valueOf())
		this.setState({ date })
	}

	singleDayDateChange(direction) {
		this.setState(prevState => {
			const date = moment.utc(prevState['date'].valueOf()).add(direction, 'days')
			this.fetchWorkoutByDate(date.valueOf())
			return { date }
		})
	}

	renderWorkouts(workout, date) {
		const { results } = this.state
		const { fetchAction, context: { i18n } } = this.props
		return (workout || []).map((ele, i) => (
			<div key={ i } className={ styles['workout-content'] }>
				<TableDay
					workout={ ele }
					date={ date }
					fetchAction={ fetchAction }
					changeDate={ this.singleDayDateChange.bind(this) }
				/>
				<div className={ styles.speedDivMain }>
					<div className={ styles.closeBar } onClick={ this.hideStuff }>{ i18n`results_label` } <FaAngleDown /></div>
					{ results ? <div className={ styles.toHide }>
						<div className={ styles.speedDiv }>
							<div>
								<p>{ i18n`rendimento_label` } (%)</p>
								<SpeedGraph width="300px" height="150px" percentage={ ele.coefficients ? ele.coefficients.yield * 100 : 0 } />
							</div>
							<div>
								<p>{ i18n`dificuldade_label` } (%)</p>
								<SpeedGraph width="300px" height="150px" percentage={ ele.coefficients ? ele.coefficients.difficulty * 100 : 0 } />
							</div>
						</div>
						<div className={ styles.greyLine } />
						<div className={ styles.speedDiv }>
							<div>
								<p>{ i18n`eficiencia_label` } (%)</p>
								<SpeedGraph width="300px" height="150px" percentage={ ele.coefficients ? ele.coefficients.ZIUT * 100 : 0 } />
							</div>
							<div>
								<p>{ i18n`resiliência_label` } (%)</p>
								<SpeedGraph width="300px" height="150px" percentage={ ele.coefficients ? ele.coefficients.resilience * 100 : 0 } />
							</div>
						</div>
					</div> : null }
				</div>
			</div>
		))
	}

	render() {
		const { fetchResults } = this.props
		const { date } = this.state
		const workout = fetchResults[date.valueOf()]
		return (
			<section>
				<div className={ styles['content'] }>
					<div className={ styles['calendar-container'] }>
						<Calendar value={ date } handleDateChange={ this.handleDateChange } />
					</div>
					<div className={ styles['workouts-container'] }>
						{ this.renderWorkouts((workout || []).length ? workout : [{ currentParams: {} }], this.state.date) }
					</div>
				</div>
			</section>
		)
	}
}

const mapStateToProps = state => ({
	fetchResults: state.fetch.results
})

export default withContext(connect(mapStateToProps)(DailyWorkoutPage))



// WEBPACK FOOTER //
// ./src/client/webapp/pages/DailyWorkoutPage/DailyWorkoutPage.js